class Pagination {
  constructor (itemsPerPage = 15) {
    this.page = 1
    this.itemsPerPage = itemsPerPage
    this.totalItems = 0
    this.totalPages = 0
    this.pagination = true
  }

  getPointer (items) {
    const firstIndex = this.page > 1 ? ((this.itemsPerPage * (this.page - 1)) + 1) : 1
    const lastIndex = firstIndex > 1 ? firstIndex + items.length - 1 : items.length
    return `${firstIndex}-${lastIndex}`
  }

  getParams () {
    return {
      page: this.page,
      itemsPerPage: this.itemsPerPage,
      pagination: this.pagination,
    }
  }

  setPage (page = 1) {
    this.page = page
  }

  updateData (data) {
    this.totalItems = data['hydra:totalItems']
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
  }
}

export default Pagination
